import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import "./LockIcon.css";

const mapStateToProps = (state) => ({ ...state });
const mapDispatchToProps = () => ({});

function UserNavi({ hideNavi }) {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleEsc = (evt) => {
      if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
        hideNavi();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [hideNavi]);

  const navItems = [
    { to: "/data", label: "Data" },
    { to: "/settings", label: "Asetukset" },
    { to: "/logout", label: "Kirjaudu ulos" },
  ];

  const handleNav = (to) => (evt) => {
    hideNavi();
    navigate(to);
    evt.preventDefault();
  };

  return (
    <>
      <div id="navi-hidden-bg" onClick={hideNavi} />
      <div id="user-navi">
        <ul>
          {navItems.map((item) => (
            <li
              key={item.to}
              className={location.pathname === item.to ? "active" : null}
            >
              <Link to={item.to} onClick={handleNav(item.to)}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserNavi);
